/**
 * Description: 显示配置中的公告信息
 * User: <changyin>
 * Date: 2017-01-04
 * Copyright(c) 2017 Taobao.com
 * update:
 *  2017-01-04 @changyin 配置的公告数据是个数组,原来只显示一条公告,改成了显示所有公告
 */
import tpl from './tpl.html';
import './style.scss';

function tip(app) {
  const config = app.appConfig;
  const autoWord = config.get('appConfig').autoWord;
  let touched = false;
  let num = 0;
  if (!autoWord) {
    return;
  }
  $(window).on('touchstart', () => {
    touched = true;
  });
  const timer = setInterval(() => {
    if (num === 30) {
      if (!touched) {
        app.appendMessage({
          type: 'robot',
          body: {
            text: autoWord,
          },
        });
      }
      clearInterval(timer);
    }
    num++;
  }, 100);
}

function card(d, app) {
  const config = app.appConfig;
  const nick = config.get('user').nick;
  const data = d.cardInfo;
  // 卡片
  app.appendMessage({
    type: 'card',
    body: {
      __scroll__: true,
      userNick: nick,
      parameters: data.parameters,
      cardId: data.styleId,
      ampTaskId: d.ampTaskId,
      onSuccess: () => {
        tip(app);
      },
    },
  });
}

function recommend(d, app) {
  const $node = $(tpl.render(d));
  const LOG_C = 'firstmsg';
  const view = app.view;
  const ampTaskId = d.ampTaskId;
  setTimeout(() => {
    app.view.body.append($node);
    tip(app);
  }, 0);

  $node.find('.J_Category').on('tap', (ev) => {
    const $target = $(ev.currentTarget);
    const $li = $target.parent();
    const ext = {};

    if ($li.hasClass('expand')) {
      $li.removeClass('expand');
    } else {
      $node.find('.expand').removeClass('expand');
      $li.addClass('expand');
    }
    $li.find('li').toggleClass('list-unfold');
    setTimeout(() => {
      if (view.body.isBottom()) {
        view.body.refresh();
        view.body.scrollToBottom();
      }
    }, 100);
    ext.id = $target.attr('data-cid');
    ext.position = $node.find('.J_Category').index($target);
    ext.ampTaskId = ampTaskId;
    console.log(ampTaskId);
    app.log.send({
      c: LOG_C,
      d: 'category',
      ext,
    });
  });

  $node.find('.J_SendText').on('tap', (ev) => {
    const $target = $(ev.currentTarget);
    const $li = $target.parent();
    const $ul = $li.parent();
    const $parentLi = $ul.parent();
    const text = $target.find('span').text();
    app.view.footer.submit(text);
    app.log.send({
      c: LOG_C,
      d: 'text',
      ext: {
        ampTaskId,
        text,
        position: $ul.find('li').index($li),
        parentPosition: $node.find('.li').index($parentLi),
      },
    });
  });
}


export default function snap(app, done) {
  const config = app.appConfig;
  const msgbox = config.get('msgbox');
  if (!msgbox) {
    done();
    return;
  }
  // const msgbox = {
  //   type: 'recommend',
  //   suggestions: [{
  //     "categoryId": "9005308",
  //     "category": "评价问题",
  //     "questions": [{
  //       "id": "6704313",
  //       "title": "我找不到评价管理怎么办？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005308",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }, {
  //       "id": "5611799",
  //       "title": "如何修改或删除评价？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005308",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }, {
  //       "id": "847751",
  //       "title": "怎么评价？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005308",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }]
  //   }, {
  //     "categoryId": "9005296",
  //     "category": "商品选购问题",
  //     "questions": [{
  //       "id": "6682466",
  //       "title": "联系不上卖家，怎么办？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005296",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }, {
  //       "id": "6703441",
  //       "title": "卖家服务太差，怎么办？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005296",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }, {
  //       "id": "1120144",
  //       "title": "如何联系卖家？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005296",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }]
  //   }, {
  //     "categoryId": "9005446",
  //     "category": "忘记密码/会员名问题",
  //     "questions": [{
  //       "id": "5601941",
  //       "title": "我注册过一个账号，但是忘记了会员名，怎么办？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005446",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }, {
  //       "id": "6672559",
  //       "title": "修改密码时，总是提示密码“设置不符合要求”，怎么办？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005446",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }, {
  //       "id": "1113700",
  //       "title": "忘记淘宝账号密码，怎么找回？",
  //       "words": null,
  //       "source": "ALGORITHM",
  //       "categoryId": "9005446",
  //       "time": "2017-05-10T05:31:44.860Z"
  //     }]
  //   }]
  // }
  const { type } = msgbox;
  if (type === 'card') {
    card(msgbox, app);
  } else if (type === 'recommend') {
    recommend(msgbox, app);
  }
  done();
}



// WEBPACK FOOTER //
// ./src/app/module/snap/index.js